/* @generated */
/* empty css                            */var boxStyles = "dig-4rjmw90_3-11-0";
export {
  boxStyles
};
